import { useState, useEffect } from 'react';
import api from '../utils/api';

const CURRENCY_SYMBOLS = {
  NGN: '\u20a6', USD: '$', GBP: '\u00a3', AED: 'AED ', CNY: '\u00a5', SAR: 'SAR ',
};

export function symFor(currency) {
  return CURRENCY_SYMBOLS[currency] || '$';
}

export function fmtAmount(amount, currency) {
  const s = symFor(currency);
  return `${s}${Math.abs(Number(amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
}

export function useCurrency() {
  const [sym, setSym] = useState('$');
  const [cur, setCur] = useState('USD');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    api.get('/wallet')
      .then((res) => {
        setCur(res.data.currency || 'USD');
        setSym(res.data.currency_symbol || '$');
      })
      .catch(() => {
        setCur('USD');
        setSym('$');
      })
      .finally(() => setLoading(false));
  }, []);

  const fmt = (amount) => `${sym}${Math.abs(Number(amount) || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

  return { sym, cur, fmt, loading };
}
